import { getBaseCrudApi } from '@/common/api/generators'

const account = {
    changePassword: 'api/common/account/password'
}

const auth = {
    login: 'api/auth/login',
    logout: 'api/auth/logout',
    data: 'api/auth/user'
}

const cmOffices = getBaseCrudApi('common/cm-offices')

const logs = {
    index (dir?: string, file?: string): string {
        let ret = 'api/common/logs'

        if (dir !== undefined) {
            ret += `?directory=${btoa(dir)}`

            if (file !== undefined) ret += `&file=${btoa(file)}`
        } else if (file !== undefined) {
            ret += `?file=${btoa(file)}`
        }

        return ret
    }
}

const permissions = {
    index: 'api/common/permissions',
    store: 'api/common/permissions',
    update (id: number): string {
        return `api/common/permissions/${id}`
    }
}

const roles = getBaseCrudApi('common/roles')

const settings = {
    index: 'api/common/settings',
    update (id: number): string {
        return `api/common/settings/${id}`
    }
}

const sharedSettings = {
    index: 'api/shared-settings'
}

const users = {
    changePassword (id: number): string {
        return `api/common/users/${id}/password`
    },
    import: 'api/common/users/import',
    ...getBaseCrudApi('common/users')
}

const version = {
    get: 'api/version'
}

export {
    account,
    auth,
    cmOffices,
    logs,
    permissions,
    roles,
    settings,
    sharedSettings,
    users,
    version
}
